import { isEmpty } from 'lodash'

import validates from 'helpers/validates'

import constants from 'constants/index'

const { STRING_SCHEMA_TYPE } = constants.validations

const cnpj = {
  name: 'cnpj',
  schemaType: STRING_SCHEMA_TYPE,
  method(message = 'CNPJ inválido') {
    return this.test(
      'cnpj',
      message,
      (value) => isEmpty(value) || validates.cnpj.isValid(value),
    )
  },
}

export default cnpj
